<div class="container">
  <div class="close" (click)="closeDialog()">
    <img src="assets/icons/news/close.svg" alt="close modal" />
  </div>
  <div class="header">
    <h1>{{ editMode ? 'Editar Empleado' : 'Agregar empleado' }}</h1>
  </div>

  <form (ngSubmit)="addEmployee()" [formGroup]="formGroup">
    <mat-form-field appearance="outline">
      <mat-label>CUIT</mat-label>
      <input
        matInput
        formControlName="cuit"
        placeholder="CUIT"
        thousandSeparator=""
        mask="separator.2"
        required
        [readonly]="editMode"
      />
      <mat-hint *ngIf="editMode">No puedes editar este campo</mat-hint>
      <mat-error
        for="cuit"
        class="form-error"
        *ngIf="
          (!formGroup.controls.cuit.pristine || formGroup.controls.cuit.touched) &&
          formGroup.controls.cuit.invalid
        "
      >
        {{ getErrorMessage('cuit') }}
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Moneda</mat-label>
      <mat-select formControlName="isArs">
        <mat-option [value]="true">AR$</mat-option>
        <mat-option [value]="false">DAI</mat-option>
      </mat-select>
      <mat-error
        for="isArs"
        class="form-error"
        *ngIf="
          (!formGroup.controls.isArs.pristine || formGroup.controls.isArs.touched) &&
          formGroup.controls.isArs.invalid
        "
      >
        {{ getErrorMessage('isArs') }}
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Salario</mat-label>
      <input
        matInput
        type="text"
        placeholder="0.00"
        mask="separator.3"
        thousandSeparator="."
        formControlName="salary"
        (blur)="($event.preventDefault)"
      />
      <mat-error
        for="salary"
        class="form-error"
        *ngIf="
          (!formGroup.controls.salary.pristine || formGroup.controls.salary.touched) &&
          formGroup.controls.salary.invalid
        "
      >
        {{ getErrorMessage('salary') }}
      </mat-error>
    </mat-form-field>

    <div class="buttons">
      <button
        type="submit"
        [disabled]="!formGroup.valid || !formGroup.dirty"
        mat-button
        class="td-btn primary"
      >
        {{ editMode ? 'Guardar Cambios' : 'Aceptar' }}
      </button>
      <button
        type="button"
        *ngIf="editMode"
        (click)="removeEmployee()"
        mat-button
        class="td-btn remove"
      >
        Eliminar empleado
      </button>
    </div>
  </form>
</div>
